module.exports = __webpack_public_path__ + "static/media/privacy-es.bc959a05.md";